/* tslint:disable */
/* eslint-disable */
export enum BusinessPhoneType {
  BUSINESS = 'BUSINESS',
  CUSTOMER_SERVICE = 'CUSTOMER_SERVICE',
  FAX = 'FAX'
}
